<ng-container *ngIf="!loading">
	<div class="grid">
		<div class="col-12 md:col-12 lg:col-12">
		  <h1 class="titulo-pagina">{{'VIGENCIADEDATOS.LBL_CONFIGURACIONDEVIGENCIAS' | translate}}</h1>
		</div>
	  </div>
	<ng-container *ngIf="permissionVIGSOL || permissionVIGTER || permissionADMDOC">
		<p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
			<p-tabPanel *ngIf="permissionVIGSOL" header="{{ 'VIGENCIADEDATOS.LBL_VIGENCIAENSOLICITUDES' | translate }}">
					<validity-requests-component [listValidityRequests]="listValidityRequests"></validity-requests-component>
			</p-tabPanel>
			<p-tabPanel *ngIf="permissionVIGTER" header="{{ 'VIGENCIADEDATOS.LBL_VIGENCIADETERCERO' | translate }}">
					<validity-employees-component [listValidityEmployees]="listValidityEmployees"></validity-employees-component>
			</p-tabPanel>
			<p-tabPanel *ngIf="permissionADMDOC" header="{{ 'VIGENCIADEDATOS.LBL_ADMINISTRACIONDEDOCUMENTOS' | translate }}">
					<administration-documents-component [listValidityDocuments]="listValidityDocuments"></administration-documents-component>
			</p-tabPanel>
		</p-tabView>
	</ng-container>
	<ng-container *ngIf="!permissionVIGSOL && !permissionVIGTER && !permissionADMDOC">
		<div class="col-md-12">
			<div class="alert-vigencia alert-vigencia-info">
				{{'VIGENCIADEDATOS.LBL_NOTIENEPERMISO' | translate }}
			</div>
		</div>
	</ng-container>
</ng-container>
<app-loading *ngIf="loading"></app-loading>
